import React from 'react';
import AdminPanel from '../components/AdminPanel';

export default function MyAppointmentsPage() {
  return <AdminPanel />;
}
